import { render, staticRenderFns } from "./TkFooter.vue?vue&type=template&id=3a4ed9c1&scoped=true&"
import script from "./TkFooter.vue?vue&type=script&lang=js&"
export * from "./TkFooter.vue?vue&type=script&lang=js&"
import style0 from "./TkFooter.vue?vue&type=style&index=0&id=3a4ed9c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4ed9c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VFooter,VIcon,VLayout,VSpacer})
